import { syncTomSelectFromNative } from './site-modal-selects';

/**
 * Site modal CF7 success handling and form reset helpers.
 *
 * @return {void}
 */
export function initSiteModalCf7() {
	const siteModalFormIds = new Set([
		'appointment',
		'contact',
		'callback',
		'specialist-finder',
		'question',
	]);

	/**
	 * @param {HTMLFormElement} form
	 * @return {void}
	 */
	const resetCf7Form = (form) => {
		const wpcf7Root = form.closest('.wpcf7');

		if (!wpcf7Root) {
			form.reset();
			return;
		}

		wpcf7Root.classList.remove(
			'sent',
			'failed',
			'invalid',
			'spam',
			'aborted',
			'unaccepted',
			'payment-required'
		);

		const responseOutput = wpcf7Root.querySelector('.wpcf7-response-output');

		if (responseOutput) {
			responseOutput.textContent = '';
			responseOutput.removeAttribute('role');
			responseOutput.classList.remove(
				'site-modal__cf7-response-output--hidden'
			);
		}

		form.reset();

		form
			.querySelectorAll('.wpcf7-not-valid')
			.forEach((field) => field.classList.remove('wpcf7-not-valid'));

		form
			.querySelectorAll('[aria-invalid="true"]')
			.forEach((field) => field.removeAttribute('aria-invalid'));

		form.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => {
			tip.remove();
		});

		const symptomsField = form.querySelector('input[name="symptoms-data"]');
		const sourceField = form.querySelector('input[name="source"]');

		if (symptomsField) {
			symptomsField.value = '';
		}

		if (sourceField) {
			sourceField.value = '';
		}

		const appointmentDateInput = form.querySelector(
			'input[name="appointment-date"]'
		);

		if (appointmentDateInput?._flatpickr) {
			appointmentDateInput._flatpickr.clear();
		}

		form.querySelectorAll('select.form-select').forEach((select) => {
			if (select instanceof HTMLSelectElement) {
				syncTomSelectFromNative(select);
			}
		});
	};

	/**
	 * @param {HTMLFormElement} form
	 * @return {void}
	 */
	const hideCf7SuccessOutput = (form) => {
		const responseOutput = form
			.closest('.wpcf7')
			?.querySelector('.wpcf7-response-output');

		if (responseOutput) {
			responseOutput.classList.add(
				'site-modal__cf7-response-output--hidden'
			);
			responseOutput.setAttribute('aria-hidden', 'true');
		}
	};

	document.addEventListener('wpcf7mailsent', (event) => {
		const form = event.target;

		if (!(form instanceof HTMLFormElement)) {
			return;
		}

		const siteModal = form.closest('.site-modal[data-modal]');

		if (!siteModal) {
			return;
		}

		const modalId = siteModal.getAttribute('data-modal') || '';

		if (!siteModalFormIds.has(modalId)) {
			return;
		}

		hideCf7SuccessOutput(form);

		document.dispatchEvent(
			new CustomEvent('lecardo-vein:modal:swap-request', {
				bubbles: true,
				detail: {
					fromModalId: modalId,
					toModalId: 'thank-you',
				},
			})
		);

		window.requestAnimationFrame(() => {
			resetCf7Form(form);
		});
	});
}
